import { render, staticRenderFns } from "./AuthorJinNangPage.vue?vue&type=template&id=f0e1f590&scoped=true"
import script from "./AuthorJinNangPage.vue?vue&type=script&lang=js"
export * from "./AuthorJinNangPage.vue?vue&type=script&lang=js"
import style0 from "./AuthorJinNangPage.vue?vue&type=style&index=0&id=f0e1f590&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0e1f590",
  null
  
)

export default component.exports